import React, { useState } from 'react';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { CampaignsList } from './components/CampaignsList/CampaignsList';
import { useCampaignsQuery } from './api/useCampaignsQuery';
import { CampaignSettings } from './components/CampaignSettings/CampaignSettings';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { CampaignsLoading } from './Campaigns.loading';

const CampaignsView = () => {
  const [campaignToUpsert, setCampaignToUpsert] = useState<any>(null);

  const { data, isFetching, isError } = useCampaignsQuery();

  useDocumentTitle('Campaigns');

  if (isFetching) {
    return <CampaignsLoading />;
  }

  if (isError) {
    return (
      <Box display="flex" justifyContent="center" p={96}>
        <ErrorState minHeight={400} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <Text as="h1" fontSize="h3" fontWeight={600} mb="32">
          Campaigns
        </Text>
        <Button
          leftIcon="far fa-plus"
          onClick={() => {
            setCampaignToUpsert({
              name: '',
              isActive: true,
              responses: 0,
              firstEngagements: 0,
              totalLeads: 0,
              leadsAccess: data.defaultLeadsAccess,
              clientAccess: {
                onboardingWorkflow: null,
                linkAccountsAccess: true,
                clientLandingPage: null,
              },
            });
          }}
          disabled={isFetching || isError}
        >
          New Campaign
        </Button>
      </Box>

      <CampaignsList campaignsList={data.campaigns} setCampaignToUpsert={setCampaignToUpsert} />

      {campaignToUpsert && (
        <CampaignSettings
          campaignsData={data}
          campaign={campaignToUpsert}
          onClose={() => setCampaignToUpsert(null)}
        />
      )}
    </>
  );
};

export default CampaignsView;
